import styled from "styled-components";
export const ButtonMenuItem = styled.div `
  min-width: 40px;
  height: 40px;
  border-radius: 8px;
  color: var(--text-primary);
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  &, * {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &[data-selected="true"] {
    background-color: var(--surface-accent);

    i {
      color: var(--text-invert);
    }
  }
`;
//# sourceMappingURL=styles.js.map